/**
 * Parses a view tag of type Javascript by executing the locator fn and returning that value
 *
 * @module
 */
var enforceType = require('./enforce_type');
var Exec = require('core/exec');

/**
 * Execute the code tag and return it's given value
 * @param {ViewTag} viewTag
 */
module.exports = function parseCodeTag(viewTag:ViewTag, parameters:any) {
  var locatorFn = viewTag.locator;
  if (typeof locatorFn === 'function') {
    var tagValue = Exec.apply(locatorFn, parameters);
    // Ensure that tagValue's type is what's expected for this tag.
    return enforceType(viewTag.valueType, tagValue);
  }
  return null;
};
